export class AppError {
    
    constructor(
        public message : string,
        public errorCode : string,
        
    ) {

    }
}